import React, { Component } from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import DocumentTitle from "react-document-title";
import { getDocumentTitle } from "../helpers";

import * as styles from "./styles.module.scss";
import SkipLink from "../../SkipLink";
import RenewalNotification from "../../RenewalNotification";
import MobileHeaderContainer from "../../../containers/MobileHeaderContainer";

/**
 * Wraps a component in the single column layout.
 *
 * @param {ReactElement} WrappedComponent The React component to wrap.
 * @param {string}       documentTitle    The document title.
 *
 * @returns {ReactElement} The single column layout with the wrapped component.
 */
export default ( WrappedComponent, documentTitle ) => {
	const wrappedName =
		WrappedComponent.WrappedComponent
			? WrappedComponent.WrappedComponent.name
			: WrappedComponent.name;
	const shouldHideButton = wrappedName === "AccountDisabled";

	return class SingleLayout extends Component {
	/**
	 * Renders the component.
	 *
	 * @returns {ReactElement} The rendered component.
	 */
		render() {
			return (
				<DocumentTitle title={ getDocumentTitle( documentTitle ) }>
					<div>
						<SkipLink>
							<FormattedMessage id="skiplink" defaultMessage="Skip to main content" />
						</SkipLink>
						<MobileHeaderContainer { ...this.props } detailPage={ true } hideButton={ shouldHideButton } />
						<div className={ classNames( styles.main, styles.single ) }>
							<RenewalNotification />
							<WrappedComponent { ...this.props } />
						</div>
					</div>
				</DocumentTitle>
			);
		}
	};
};
